import { ConfirmationModal, Text } from '@shared/components';
import { useSnackbar } from '@shared/snackbar';
import { GetAppRolesDocument, useDeleteAppRoleMutation } from '@user-management/graphql';

enum DeleteAppRoleErrorType {
  // NOTED: Assume that the error message which is DOES_NOT_HAVE_PERMISSION_TO_UPDATE is the prohibited for deleting their role
  DELETE_THEIR_ROLE = 'DOES_NOT_HAVE_PERMISSION_TO_UPDATE',
}

const ERROR_MESSAGE: Record<DeleteAppRoleErrorType, string> = {
  [DeleteAppRoleErrorType.DELETE_THEIR_ROLE]: 'ไม่สามารถลบ Role ที่มีตัวเองอยู่ได้',
};

interface RoleDeletionModalProps {
  open: boolean;
  onClose: () => void;
  roleId?: string;
}

export default function RoleDeletionModal(props: Readonly<RoleDeletionModalProps>) {
  const { open: isOpen, onClose, roleId } = props;

  const { showSnackbar } = useSnackbar();

  const [deleteAppRole, { loading: isLoading }] = useDeleteAppRoleMutation();

  const handleDeleteRole = () => {
    deleteAppRole({
      variables: { data: { appRoleId: roleId ?? '' } },
      onCompleted: (res) => {
        if (res.suDeleteAppRole.success) {
          showSnackbar({ message: 'ลบข้อมูลสำเร็จ', variant: 'success' });
          onClose();
        } else {
          let message = res.suDeleteAppRole.message ?? 'ลบข้อมูลไม่สำเร็จ';
          if (message.includes(DeleteAppRoleErrorType.DELETE_THEIR_ROLE)) {
            message = ERROR_MESSAGE[DeleteAppRoleErrorType.DELETE_THEIR_ROLE];
          }
          showSnackbar({ message: message, variant: 'error' });
        }
      },
      onError: (error) => {
        showSnackbar({ message: error.message, variant: 'error' });
      },
      awaitRefetchQueries: true,
      refetchQueries: [GetAppRolesDocument],
    });
  };

  return (
    <ConfirmationModal
      open={isOpen}
      title='Delete Role?'
      variant='error'
      discardText='Cancel'
      acceptText='Delete Role'
      loading={isLoading}
      onDiscard={onClose}
      onClose={onClose}
      onAccept={handleDeleteRole}
      content={
        <Text>
          การ Remove Role{' '}
          <Text component='span' variant='body1Semibold'>
            จะทำให้ยกเลิกเข้าถึงฟีเจอร์ที่ทั้งหมดที่เกี่ยวข้องกับบทบาทของผู้ใช้
          </Text>
          กรุณาตรวจสอบให้แน่ใจก่อนดำเนินการ
        </Text>
      }
    />
  );
}
